import { ExpiryRenewalAction } from 'actions/expiryRenewalActions';
import { ExpiryRenewalState } from 'types/expiryRenewal';

const initialState: ExpiryRenewalState = {
  addOns: {
    selected: [],
  },
  removedExtras: [],
  basket: {
    totalPrice: null,
    wasPrice: null,
    usePreviousCardDetails: false,
  },
  monthlyFlex: false,
  pageModel: null,
  policyLockToken: null,
  toggles: {
    autoRenew: false,
    paperless: true,
  },
  paymentData: null,
  useDefaultStepper: false,
  renewalTermsAccepted: false,
  amendments: [],
};

const expiryRenewalReducer = (
  state: ExpiryRenewalState = initialState,
  action: ExpiryRenewalAction,
): ExpiryRenewalState => {
  switch (action.type) {
    case 'SET_PAGEMODEL':
      return { ...state, pageModel: { ...action.payload } };
    case 'SET_LOCK_TOKEN':
      return { ...state, policyLockToken: action.payload };
    case 'SET_PAYMENT_DATA':
      return { ...state, paymentData: { ...action.payload } };
    case 'SET_ADDONS':
      return { ...state, addOns: { ...state.addOns, selected: action.payload } };
    case 'SET_REMOVED_EXTRAS':
      return { ...state, removedExtras: action.payload };
    case 'SET_MONTHLY_FLEX':
      return { ...state, monthlyFlex: action.payload };
    case 'SET_AUTORENEW':
      return { ...state, toggles: { ...state.toggles, autoRenew: action.payload } };
    case 'SET_PAPERLESS':
      return { ...state, toggles: { ...state.toggles, paperless: action.payload } };
    case 'SET_BASKET':
      return { ...state, basket: { ...state.basket, ...action.payload } };
    case 'SET_RENEWAL_TERMS_ACCEPTED':
      return { ...state, renewalTermsAccepted: action.payload };
    case 'SET_USE_DEFAULT_STEPPER':
      return { ...state, useDefaultStepper: action.payload };
    case 'SET_AMENDMENTS':
      return { ...state, amendments: action.payload };
    default:
      return state;
  }
};

export default expiryRenewalReducer;
